<h3 class="modal-header--title {{ headingClass }} text-break" [class.mb-0]="!heading">
  {{ heading }}
</h3>

<div class="modal-header--close">
  <svg *ngIf="!hideCloseButton" cfIcon="cross" (click)="activeModal.dismiss(); emitDismiss.emit()"></svg>
</div>
